import { Link as RouterLink } from 'react-router-dom'
import {
  Box,
  Button,
  Flex,
  Heading,
  Text,
  useColorMode,
} from '@chakra-ui/react'
import { motion } from 'framer-motion'
import { ChevronDown } from 'lucide-react'

const MotionBox = motion.create(Box)

export function HeroSection() {
  const { colorMode } = useColorMode()
  const isDark = colorMode === 'dark'

  return (
    <Flex
      minH="100vh"
      direction="column"
      align="center"
      justify="center"
      textAlign="center"
      px={6}
      pt="56px"
      position="relative"
      bgGradient={
        isDark
          ? 'linear(to-b, stone.900, stone.950)'
          : 'linear(to-b, stone.100, stone.50)'
      }
    >
      {/* Emerald glow */}
      <Box
        position="absolute"
        top={0}
        left="50%"
        transform="translateX(-50%)"
        w="120%"
        h="60%"
        bgGradient={
          isDark
            ? 'radial(ellipse 70% 50% at 50% 0%, rgba(16,185,129,0.14), transparent)'
            : 'radial(ellipse 70% 50% at 50% 0%, rgba(16,185,129,0.18), transparent)'
        }
        pointerEvents="none"
        aria-hidden="true"
      />

      {/* Overline */}
      <Text
        fontSize="13px"
        fontWeight={500}
        color="brand.400"
        textTransform="uppercase"
        letterSpacing="0.1em"
        mb={6}
        position="relative"
      >
        Markdown Sharing
      </Text>

      {/* Headline */}
      <Heading
        as="h1"
        fontFamily="heading"
        fontWeight={700}
        fontSize={{ base: '3rem', md: '4rem', lg: '5rem' }}
        letterSpacing="-0.035em"
        lineHeight={1.1}
        color={isDark ? 'stone.50' : 'stone.900'}
        maxW="800px"
        position="relative"
      >
        Your Markdown{' '}
        <Box as="br" display={{ base: 'none', md: 'block' }} />
        deserves a shareable link.
      </Heading>

      {/* Subheadline */}
      <Text
        fontSize="1.25rem"
        color="stone.400"
        mt={6}
        maxW="520px"
        lineHeight={1.7}
        position="relative"
      >
        AI writes Markdown. Your team needs the outcome. myrkup turns it into an encrypted link in seconds.
      </Text>

      {/* Single CTA */}
      <Button
        as={RouterLink}
        to="/editor"
        size="lg"
        mt={12}
        position="relative"
      >
        Start Sharing
      </Button>

      {/* Trust line */}
      <Text
        mt={5}
        fontSize="13px"
        color="stone.500"
        letterSpacing="0.02em"
        position="relative"
      >
        End-to-end encrypted · Try now, no account required
      </Text>

      {/* Scroll hint */}
      <MotionBox
        mt={16}
        animate={{ y: [0, 6, 0] }}
        transition={{ duration: 2, repeat: Infinity, ease: 'easeInOut' }}
        aria-hidden="true"
      >
        <ChevronDown size={24} color={isDark ? '#78716c' : '#a8a29e'} />
      </MotionBox>
    </Flex>
  )
}
